var _objectSpread = require("E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var _objectWithoutProperties = require("E:/workspace/ysorder/order_admin_client/node_modules/@babel/runtime/helpers/objectWithoutProperties.js").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: ["icon", classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "viewBox": "0 0 1024 1024",
        "xmlns": "http://www.w3.org/2000/svg",
        "width": "200",
        "height": "200"
      }, attrs)
    }, rest), children.concat([_c('defs'), _c('path', {
      attrs: {
        "d": "M691.2 870.4h-384c-14.336 0-25.6-11.264-25.6-25.6s11.264-25.6 25.6-25.6h384c14.336 0 25.6 11.264 25.6 25.6s-11.264 25.6-25.6 25.6z"
      }
    }), _c('path', {
      attrs: {
        "d": "M874.496 998.4H149.504c-42.496 0-76.8-34.304-76.8-76.8l.512-7.168 58.368-614.4c3.584-39.936 36.352-69.632 76.288-69.632h608.256c39.936 0 72.704 29.696 76.288 69.632l58.368 614.4c2.048 20.48-4.096 40.448-17.408 56.32-12.8 15.872-31.744 25.6-52.224 27.648h-6.656zM207.872 281.6a25.6 25.6 0 00-25.6 23.04l-58.368 614.4c0 16.384 11.264 28.16 25.6 28.16h724.48c9.216-1.024 15.36-4.096 19.968-9.216s6.144-11.776 5.632-18.432l-58.368-614.4a25.242 25.242 0 00-25.6-23.04H207.872z"
      }
    }), _c('path', {
      attrs: {
        "d": "M716.8 384c-14.336 0-25.6-11.264-25.6-25.6V256c0-98.816-80.384-179.2-179.2-179.2S332.8 157.184 332.8 256v102.4c0 14.336-11.264 25.6-25.6 25.6s-25.6-11.264-25.6-25.6V256c0-126.976 103.424-230.4 230.4-230.4S742.4 129.024 742.4 256v102.4c0 14.336-11.264 25.6-25.6 25.6z"
      }
    })]));
  }
};